<template>
  <div id="app">
    <nprogress-container></nprogress-container>

    <logo-loader :isActive="logoLoaderActive"></logo-loader>

    <template v-if="!$auth.ready()">LOADING...</template>

    <template v-if="isVerified"></template>

    <!-- <holiday-bar></holiday-bar> -->

    <!-- div id="top-notice">
      <div class="wrap">
        <div class="columns is-vcentered">
          <div class="column is-1 icon">
            <span class="icon">
              <i class="fa fa-snowflake-o"></i>
            </span>
          </div>
          <div class="column content">
            <h4>HOLIDAY SCHEDULE NOTICE</h4>
            <p>
              Please be aware that starting 24.12.2020 our offices will be following a holiday schedule. For details of our working hours during the holiday period, <a @click="scheduleModal = true">click here</a>.</strong>
            </p>
          </div>
        </div>
      </div>
    </div -->

    <!-- div
      class="modal small"
      :class="{ 'is-active': scheduleModal }"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">HOLIDAY SCHEDULE</p>
          <button
            class="delete"
            @click="scheduleModal = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <table class="table is-striped is-responsive is-fullwidth">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Working Hours</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Thursday, 24/12/2020</td>
                    <td>Service until 13:00 GMT</td>
                  </tr>
                  <tr style="border-bottom: 2px;">
                    <td>Friday, 25/12/2020</td>
                    <td class="has-text-weight-bold">Closed</td>
                  </tr>
                  <tr>
                    <td>Monday, 28/12/2020</td>
                    <td class="has-text-weight-bold">Closed</td>
                  </tr>
                  <tr>
                    <td>Tuesday, 29/12/2020</td>
                    <td>Working</td>
                  </tr>
                  <tr>
                    <td>Wednesday, 30/12/2020</td>
                    <td>Working</td>
                  </tr>
                  <tr>
                    <td>Thursday, 31/12/2020</td>
                    <td>Service until 13:00 GMT</td>
                  </tr>
                  <tr>
                    <td>Friday, 01/01/2021</td>
                    <td class="has-text-weight-bold">Closed</td>
                  </tr>
                  <tr>
                    <td>Monday, 04/01/2021</td>
                    <td>Working</td>
                  </tr>
                </tbody>
              </table>

              <div class="pt-2">
                For trading hours during the holiday period, <a
                  target="_blank"
                  :href="websiteURL + 'holiday-schedule/'"
                >click here</a>.
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot right">
          <button
            class="button"
            @click="scheduleModal = false"
          >{{ $t('close').tUpper() }}</button>
        </footer>
      </div>
    </div -->

    <template v-if="$auth.ready()">
      <template v-if="!$route.meta.skipStructure">
        <div
          id="new-version-message"
          v-if="newAppVersion"
          @click="reload()"
        >
          <p class="title is-size-5">{{$t('new_version_note')}}</p>
          <p class="subtitle">{{$t('new_version_note1')}}</p>
        </div>

        <new-terms-modal
          v-if="User.info.ID && $getCookie('login_license_read').length == 0"
          :user-id="User.info.ID"
        ></new-terms-modal>

        <header :class="$route.name">
          <div
            @click="firstLogin(uploadDocumentsURL)"
            class="notification uploadDocuments is-primary"
            v-if="User.info.client && User.info.client.verified !== 'yes' && !isRegistration && isLive && DocCount == 0"
          >
            <p v-html="$t('upload_documents_notice')"></p>
          </div>
          <div class="headWrap">
            <div
              :href="'/' + Language + '/'"
              class="logo"
              :class="{'is-pulled-right logo-fa': Language == 'fa' || Language == 'ar', 'is-pulled-left' : Language != 'fa' && Language != 'ar'}"
            >
              <span
                v-show="!isRegistration"
                @click="sidenavHidden = !sidenavHidden"
                :class="{'is-pulled-right': Language == 'fa' || Language == 'ar','is-pulled-left': Language != 'fa' && Language != 'ar'}"
                class="hamb icon is-large has-text-white is-hidden-desktop"
              >
                <i class="fa fa-2x fa-bars"></i>
              </span>
              <a :href="'/' + Language + '/'">
                <img src="./assets/img/eurotrader_logo_rgb_white.svg" />
              </a>
            </div>
            <h1
              class="title is-hidden-touch"
              :class="{'float-right-only': Language == 'fa' || Language == 'ar'}"
            >{{ parentHeading }}</h1>

            <div
              class="action"
              :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right' : Language != 'fa' && Language != 'ar'}"
              v-if="!$auth.check()"
            >
              <router-link
                class="button is-primary main login is-pulled-right"
                :to="'/' + Language + '/login'"
              >{{ $t('login').tUpper() }}</router-link>
            </div>

            <div
              class="action is-unselectable"
              :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right' : Language != 'fa' && Language != 'ar'}"
              v-if="!isRegistration"
            >
              <div
                class="dropdown user"
                :class="{ 'is-active': userHeadMenuActive, 'is-left ': Language == 'fa' || Language == 'ar', 'is-right is-pulled-right' : Language != 'fa' && Language != 'ar' }"
              >
                <div class="dropdown-trigger">
                  <div
                    aria-haspopup="true"
                    aria-controls="user-dropdown"
                    @click="userHeadMenuActive = !userHeadMenuActive"
                  >
                    <span class="welcome">
                      <span class="is-hidden-touch">{{ $t('welcome').tTitle() }}, {{ displayName }} |</span>
                      <span class="has-text-white has-text-weight-normal">
                        {{ $t('wallet_balance').tTitle() }}
                        <b>{{ $formatMoney(Math.floor(User.wallet.balance * 100) / 100, currencySymbols[User.wallet.currency]) }}</b>
                      </span>
                    </span>
                    <span class="profile-head-icon">
                      <img
                        src="./assets/img/icons/profile-head.svg"
                        alt
                      />
                    </span>
                    <span class="icon is-small">
                      <i
                        class="fa fa-angle-down"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </div>
                <div
                  class="dropdown-menu user"
                  id="user-dropdown"
                  role="menu"
                >
                  <div class="dropdown-content">
                    <div class="dropdown-item big">
                      <p
                        class="is-hidden-desktop has-text-left"
                        style="padding-top:35px;"
                      >
                        {{ $t('welcome').tTitle() }},
                        <b>{{ displayName }}</b>
                      </p>
                      <p
                        class="balance"
                        :class="{ 'is-pulled-right ': Language == 'fa' || Language == 'ar', 'is-pulled-left' : Language != 'fa' && Language != 'ar' }"
                      >
                        {{ $t('wallet_balance') }}
                        <br />
                        <span>{{ $formatMoney(Math.floor(User.wallet.balance * 100) / 100, currencySymbols[User.wallet.currency]) }}</span>
                      </p>
                    </div>

                    <div
                      :class="{ 'is-pulled-left ': Language == 'fa' || Language == 'ar', 'position-right' : Language != 'fa' && Language != 'ar' }"
                      class="dropdown-item logout-dropdown-item"
                    >
                      <div
                        v-if="$auth.check()"
                        class="button is-fullwidth main is-primary"
                        v-on:click="logout()"
                      >{{ $t('logout').tUpper() }}</div>
                    </div>

                    <div class="dropdown-item profile_buttons">
                      <div
                        class="button is-fullwidth is-primary"
                        @click="uddGoTo('/' + Language + '/finance/deposit')"
                      >{{ $t('deposit').tUpper() }}</div>
                      <div
                        class="button is-fullwidth is-black"
                        @click="uddGoTo('/' + Language + '/finance/withdraw')"
                      >{{ $t('withdraw').tUpper() }}</div>
                      <div
                        class="button is-fullwidth is-primary is-outlined"
                        @click="uddGoTo('/' + Language + '/finance/internal-transfer')"
                      >{{ $t('internal_transfer').tUpper() }}</div>
                    </div>

                    <div class="dropdown-item lang-dropdown-item">
                      <div class="is-fullwidth is-right is-pulled-right">
                        &nbsp;
                        <span class="select clean is-small">
                          <language />
                        </span>
                      </div>

                      <router-link
                        v-if="!$auth.check()"
                        class="button is-primary is-fullwidth main login is-pulled-right"
                        :to="'/' + Language + '/login'"
                      >{{ $t('login').tUpper() }}</router-link>
                      <div class="is-clearfix"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="action is-pulled-right has-text-weight-bold">
						<a href="https://www.eurotrader.eu/en/reset-mt4-password/" target="_blank">Reset your MT4 passwords</a>
            </div>-->
          </div>
        </header>
      </template>
      <main
        :class="{ solo: $route.meta.skipStructure, register: isRegistration, noSideNav: sidenavHidden }"
        :section_name="$route.name"
      >
        <template v-if="User.info.first_login === 'no' && $route.name !== 'Verify email | english'">
          <article class="message">
            <div class="message-header">
              <p
                v-if="isIB"
                v-html="$t('welcome_title_ib')"
              ></p>
              <p
                v-else-if="isLive"
                v-html="$t('welcome_title_live')"
              ></p>
              <p
                v-else
                v-html="$t('welcome_title_demo')"
              ></p>
              <button
                class="delete"
                aria-label="delete"
                @click="firstLogin()"
              ></button>
            </div>
            <div
              class="message-body"
              v-if="isIB"
              v-html="$t('welcome_text_ib', { contactURL: contactURL })"
            ></div>
            <div
              class="message-body"
              v-else-if="isLive"
              v-html="$t('welcome_text_live', { contactURL: contactURL })"
            ></div>
            <div
              class="message-body"
              v-else
              v-html="$t('welcome_text_demo', { contactURL: contactURL, platformDownloadURL: downloadURL })"
            ></div>

            <div
              class="button is-primary"
              @click="firstLogin()"
            >{{ $t('done').tUpper() }}</div>
          </article>
        </template>
        <template v-else>
          <template v-if="!$route.meta.skipStructure">
            <section
              class="sidenav"
              :class="{ 'is-hidden': sidenavHidden,'float-right-only': Language == 'fa' || Language == 'ar' }"
              v-if="!isRegistration"
            >
              <div
                v-if="User.info.client && User.info.client.account_state"
                class="account-status"
                :class="User.info.client.account_state"
              >
                <div :class="{ 'direction-rtl': Language == 'fa' || Language == 'ar' }">{{ $t('account') }} {{ status[User.info.client.account_state]=='Approved' ? $t('client_state_approved') : $t('client_state_pending') }}</div>
              </div>
              <ul :class="{ 'direction-rtl': Language == 'fa' || Language == 'ar' }">
                <li
                  v-for="(item, index) in Menu"
                  v-if="!item.meta || item.meta.skipMenu !== true"
                  :class="{ 'is-active': item.meta.active }"
                  :key="index"
                >
                  <router-link
                    :class="{ 'is-active': item.meta.active }"
                    :to="'/' + Language + (item.path || item.children[0].path)"
                  >
                    {{ $t(item.meta.T) }}
                    <i :class="{'icon-right': Language == 'fa' || Language == 'ar', ['icon ' + item.meta.icon]:true}"></i>
                  </router-link>
                </li>
              </ul>
              <div
                class="button centered is-primary"
                v-if="isDemo"
              >
                <router-link :to="'/' + Language + '/register/upgrade'">{{ $t('upgrade_to_live_account').tUpper() }}</router-link>
              </div>

              <template v-if="isLive && !isIB">

                <div
                  class="button centered is-primary"
                  @click="becomeAnIBModalActive = true"
                >{{ $t('become_a_partner').tUpper() }}</div>
              </template>
            </section>

            <div
              v-if="isLive && !isIB"
              class="modal small"
              :class="{ 'is-active': becomeAnIBModalActive }"
            >
              <div class="modal-background"></div>
              <div class="modal-card">
                <section class="modal-card-body">
                  <div class="columns">
                    <div class="column">
                      <label
                        class="label"
                        for="target_region"
                      >{{ $t('what_geographic_region') }}</label>
                      <div class="control">
                        <input
                          class="is-fullwidth"
                          name="ib_main_target_region"
                          id="target_region"
                          v-model="ibMainTargetRegion"
                        />
                        <p
                          class="convertPartnerCurrencyWarning"
                          v-if="User.wallet.currency !== 'USD'"
                        >{{ $t('note_wallet_currency_conversion_partner') }}</p>
                      </div>
                    </div>
                  </div>
                </section>
                <footer class="modal-card-foot right">
                  <button
                    class="button"
                    @click="becomeAnIBModalActive = false"
                  >{{ $t('cancel').tUpper() }}</button>
                  <button
                    class="button is-primary"
                    @click="updateToAnIB()"
                  >{{ $t('become_a_partner').tUpper() }}</button>
                </footer>
              </div>
            </div>

            <section
              class="topnav"
              :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
              v-if="!isRegistration && !$route.meta.skipTopNav"
            >
              <nav class="nav">
                <div class="nav-left">
                  <template v-for="(item, index) in Menu">
                    <template v-if="item.meta.active && item.children && item.children.length">
                      <template v-for="child in item.children">
                        <router-link
                          class="nav-item"
                          v-if="child.meta.skipMenu !== true && extraMenuItemChecksPassed(child)  === true"
                          :class="{ 'is-active': child.meta.navActive }"
                          :to="'/' + Language + item.path + (child.path || '')"
                          :key="index + '-' + child.path"
                        >
                          <template v-if="child.meta.Ticon">
                            <i :class="'icon ' + child.meta.Ticon"></i>
                          </template>
                          <template v-else>{{ $t(child.meta.T).tUpper() }}</template>
                        </router-link>
                      </template>
                    </template>
                  </template>
                </div>
              </nav>
            </section>
          </template>

          <section :id="$route.meta.noContentPadding ? '' : 'content'">
            <h2
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              v-if="!$route.meta.skipStructure && !isRegistration && !$route.meta.skipHeading"
            >{{ heading }}</h2>
            <router-view :platformImages="platformImages"></router-view>
            <div class="is-clearfix"></div>
          </section>

          <div class="is-clearfix"></div>
        </template>
      </main>

      <!-- <live-feed v-if="!isRegistration"></live-feed> -->

      <template v-if="!$route.meta.skipFooter">
        <footer>
          <div
            id="footerMain"
            :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
          >
            <div id="footerRow1">
              <div
                id="footerLogoContainer"
                :class="{'float-right-only': Language == 'fa' || Language == 'ar'}"
              >
                <a
                  class="logo"
                  href="/"
                >
                  <img src="./assets/img/eurotrader_logo_rgb_white.svg" />
                </a>
              </div>
            </div>

            <div id="footerRow2">
              <div class="contentLeft">

                <p
                  style="margin-bottom:40px;"
                  v-html="$t('footer_certificate_eurotrader', { link: 'https://financialcommission.org/eurotrader/' })"
                ></p>
                <p class="footerTitle">{{$t("risk_warning")}}</p>
                <p v-html="$t('footer_risk_warning', { brokerURL: this.websiteURL, urlRandomString: this.$randomString() })"></p>
              </div>

              <div class="contentRight">
                <div class="contacts">
                  <h2 style="font: normal normal 650 12px/14px Roboto;color: #6826F4;">{{$t('contact').tUpper()}}</h2>
                  <br />

                  <p>+44 (0)20 8004 7430</p>
                  <p>support@eurotrader.com</p>
                  <br>

                  <!-- <a href="https://www.facebook.com/eurotraderhub/">
                    <img
                      src="./assets/img/icons/footer/facebook.svg"
                      width="31"
                      style="margin:0 10px 0 0"
                      alt="FX Commodities"
                    />
                  </a>
                  <a href="https://twitter.com/eurotraderhub">
                    <img
                      src="./assets/img/icons/footer/twitter.svg"
                      width="31"
                      style="margin:0 10px 0 0"
                      alt="ECN"
                    />
                  </a>
                  <a href="https://www.linkedin.com/company/eurotraderhub/">
                    <img
                      src="./assets/img/icons/footer/linkedin.svg"
                      width="31"
                      style="margin:0 10px 0 0"
                      alt="STP execution"
                    />
                  </a> -->
                </div>
              </div>
            </div>
            <!-- ends footerRow2 -->
          </div>
        </footer>
      </template>
    </template>
  </div>
</template>



<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import LiveFeed from './components/LiveFeed'
import { mapGetters, mapActions } from 'vuex'
import { service } from './app'
import config from './config'
import api from './api'
import logoLoader from './components/LogoLoader.vue'
import Language from './components/Language'
import { sendClientData } from './util/ga';

import NewTermsModal from './components/NewTermsModal'
// import HolidayBar from './components/HolidayBar.vue'

// load platform images
const pathToLogos = require.context('./assets/img/logos', true)
const platformImages = { mt4: '', mt5: '', pamm: '' }
let platNames = Object.keys(platformImages)
for (let i = 0, l = platNames.length; i < l; i++) {
  platformImages[platNames[i]] = pathToLogos('./' + platNames[i] + '-small.png', true)
}

export default {
  components: {
    NprogressContainer,
    LiveFeed,
    logoLoader,
    Language,
    NewTermsModal,
    // HolidayBar,
  },
  data() {
    return {
      parentHeading: '',
      heading: '',
      platformImages,
      isRegistration: false,
      sidenavHidden: true,
      becomeAnIBModalActive: false,
      ibMainTargetRegion: '',
      userHeadMenuActive: false,
      currencySymbols: config.currencies,
      newAppVersion: false,
      status: {
        incomplete: 'Incomplete',
        pending: 'Pending',
        full: 'Approved',
      },
      scheduleModal: false,
    }
  },
  head: {
    title: function () {
      return {
        inner: this.heading,
      }
    },
  },
  watch: {
    Language(l) {
      if (l === null || typeof l === 'undefined') {
        return
      }
      let url = location.pathname.split('/')
      if (url[1] !== l) {
        url[1] = l
        this.$locale.change(l)
        window.localStorage.setItem('lang', l)
        this.$router.push(url.join('/'))
      }
    },
    UserInfo(u) {
      if (u.ID <= 0) {
        return
      }
      if (typeof u.firstname === 'undefined') {
        this.getUserDetails()
      } else if (!this.isRegistration) {
        // todo: this part is not required. Find a more standard way to update wallet balance
        api.GetWallet()
      }
    },
    $route(route) {
      this.isRegistration = typeof this.$route.meta.registerComponent !== 'undefined'
      this.$bus.$emit('LiveFeedConnect')
      if (this.User.accountTypes.length) {
        this.getParentMenu(route)
      }
    },
  },
  computed: {
    displayName() {
      if (!this.User.info.client) {
        return '-'
      }

      let firstName = this.User.info.firstname
      let lastName = this.User.info.lastname
      firstName = firstName.trim()
      lastName = lastName.trim()

      if (firstName !== '' && lastName !== '') {
        return `${firstName} ${lastName}`
      }

      let companyName = this.User.info.client.company_name
      companyName = companyName.trim()
      if (companyName !== '') {
        return companyName
      }

      return ''
    },
    isDemo() {
      let isDemo
      if (!this.User.accountTypes.length) {
        isDemo = false
      } else {
        isDemo = this.User.accountTypes.indexOf('demo') !== -1 && this.User.accountTypes.indexOf('live') === -1
      }
      this['user/setIsDemo'](isDemo)
      return isDemo
    },
    isLive() {
      let isLive
      if (!this.User.accountTypes.length) {
        isLive = false
      } else {
        isLive = this.User.accountTypes.indexOf('live') !== -1
      }
      this['user/setIsLive'](isLive)
      return isLive
    },
    isVerified() {
      let isVerified
      if (typeof this.User.info.client === 'undefined') {
        isVerified = false
      } else if (this.User.info.client.verified != 'yes') {
        isVerified = false
      } else {
        isVerified = true
      }
      this['user/setIsVerified'](isVerified)
      return isVerified
    },
    isIB() {
      if (!this.User.accountTypes.length) {
        return false
      }
      return this.User.accountTypes.indexOf('ib') !== -1
    },
    profileCompleted() {
      if (typeof this.User.info.client !== 'undefined' && this.User.info.client.criminal_activity !== undefined) {
        return true
      } else {
        return false
      }
    },
    uploadDocumentsURL() {
      return '/' + this.Language + '/profile/upload-documents'
    },
    downloadURL() {
      return '/' + this.Language + '/trading-account/download'
    },
    contactURL() {
      return config.URL.website + 'contact'
    },
    websiteURL() {
      return config.URL.website
    },
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      UserInfo: 'user/info',
      DocCount: 'user/docCount',
      Menu: 'menu/all',
      logoLoaderActive: 'logoLoader/active',
      BonusConfig: 'bonusconfig/all',
    }),
  },
  created() {
    this.isRegistration = typeof this.$route.meta.registerComponent !== 'undefined'
    this.$bus.$on('ChangeLang', this.changeLang)
    this.$bus.$on('ChangeHeadings', this.changeHeadings)
    this.$bus.$on('forceUpdate', this.$forceUpdate())
  },
  mounted() {
    // if (this.$route.name === '404') {
    // 	this.$router.push('/' + this.Language + '/' + config.defaultURL)
    // }
    // console.log(require('../package.json').version)

    setTimeout(() => {
      if (this.$auth.check() && this.$route.path.includes('404')) {
        this.$router.push('/' + (this.Language || 'en') + '/' + config.defaultURL)
      }
    }, 2000)

    // this.newAppVersion = true
    if (window.localStorage) {
      this.checkAppVersion()
      setInterval(() => {
        this.checkAppVersion()
      }, 10000)
    }

    this.$el.addEventListener('click', this.docClick)

    this.getBonusConfig()
  },
  beforeDestroy() {
    this.$el.removeEventListener('click', this.docClick)
    this.$bus.$off('ChangeLang', this.changeLang)
    this.$bus.$off('ChangeHeadings', this.changeHeadings)
    this.$bus.$off('forceUpdate', this.$forceUpdate())
  },
  methods: {
    getBonusConfig() {
      service.get('/bonus/config').then(response => {
        var bonusConfig = {
          depositBonus: {
            enabled: response.data.deposit_bonus_enabled,
          },
          noDepositBonus: {
            enabled: response.data.no_deposit_bonus_enabled,
          },
        }

        this['bonusconfig/set'](bonusConfig)
      })
    },
    reload() {
      location.reload()
    },
    checkAppVersion() {
      let storageVersion = window.localStorage.getItem('app-version')
      let request = new XMLHttpRequest()
      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            if (request.responseText) {
              let data = JSON.parse(request.responseText)
              let latestVersion = data.version
              if (storageVersion === '') {
                // if storage version is empty for some reason, just set it
                window.localStorage.setItem('app-version', latestVersion)
              } else if (storageVersion !== latestVersion) {
                // show update message
                this.newAppVersion = true
              } else {
                // this is for reactive changes(local dev) or for setting the
                // version number to previous values(not sure why we'll need that)
                this.newAppVersion = false
              }
            }
          } else {
            // 'An error occurred during your request: ' +  request.status + ' ' + request.statusText
          }
        }
      }
      request.open('get', '/static/auto-generated.json')
      request.send()
    },
    checkAllowedLink(metaData) {
      if (metaData.liveOnly == true) {
        if (this.isDemo) {
          return false
        }
      }
      return true
    },
    updateToAnIB() {
      if (!this.ibMainTargetRegion) {
        this.$toasted.error('"' + this.$t('what_geographic_region') + '" - ' + this.$t('required') + '<span class="error-id"></span>', { duration: 4000 })
        return
      }
      service
        .post('/users/upgrade/ib', {
          userID: this.User.info.ID,
          target_region: this.ibMainTargetRegion,
        })
        .then(response => {
          if (response.data.success) {
            // reload account types
            this['user/setAccountTypes']([])
            api.GetUserAccountTypes().then(() => {
              this.getParentMenu(this.$route)
              // reset IB data, redirect
              this['user/setIB']({})
              this.$router.push('/' + this.Language + '/partner/overview')
            })
          }
        })
    },
    changeHeadings(heading, parent) {
      if (heading) {
        this.heading = heading // .tUpper()
        this.$emit('updateHead')
      }
      if (parent) {
        this.parentHeading = parent // .tUpper()
      }
    },
    docClick(e) {
      // parent emit clicks
      if (!e.target) {
        return
      }

      // close mobile menu
      if (window.innerWidth <= 768 && !this.sidenavHidden) {
        let isHambIcon = this.$elementParentExists(e.target, document.querySelector('span.hamb'))
        if (!isHambIcon) {
          this.sidenavHidden = true
        }
      }

      if (!this.isRegistration && !this.$route.meta.skipStructure) {
        // close live feed - #openTradeNewsFeedSection
        let isLiveFeed = this.$elementParentExists(e.target, document.querySelector('#liveFeed'))
        if (!isLiveFeed) {
          this.$bus.$emit('LiveFeedToggleMode')
        }
      }

      // close user dropdown
      let isUserDropDown = this.$elementParentExists(e.target, document.querySelector('.dropdown.user'))
      if (!isUserDropDown && this.userHeadMenuActive) {
        this.userHeadMenuActive = false
      }
      this.$bus.$emit('AppClick', e)
    },
    getUserDetails() {
      if (!this.User.info.ID) {
        return
      }

      // get user data
      service.get('/users/' + this.User.info.ID, null, 'getuserdetails').then(response => {
        let userInfo = response.data
        userInfo.ID = this.User.info.ID
        this['user/setInfo'](userInfo)

        let lang = this.User.info.preferred_language
        let localLang = window.localStorage.getItem('lang')
        if (!localLang) {
          this['language/set'](lang)
          window.localStorage.setItem('lang', lang)
          // check if url has language already
          let url = location.pathname.split('/')
          if (url[1] === '' || url[1].length !== 2) {
            this.$router.push('/' + this.Language + '/' + config.defaultURL)
          }
          this.$locale.change(this.Language)
        }

        sendClientData(this.User.info.ID, "COM");

        api.GetUserAccountTypes().then(() => {
          this.getParentMenu(this.$route)
          if (!this.isRegistration) {
            api.GetWallet()
            api.GetPSPBlockedCountries()
            api.GetDocumentCount()
          }
        })
      })
    },
    checkMenuPrivileges(item) {
      if (!this.User.accountTypes.length) {
        return
      }
      if (typeof item.meta.needsPrivileges !== 'undefined') {
        item.meta.skipMenu = true
        for (let i = 0, l = item.meta.needsPrivileges.length; i < l; i++) {
          if (this.User.accountTypes.indexOf(item.meta.needsPrivileges[i]) !== -1) {
            item.meta.skipMenu = false
          }
        }
      }

      if (typeof item.meta.needsVerified !== 'undefined') {
        if (item.meta.needsVerified == 'yes' && !this.isVerified) {
          item.meta.skipMenu = true
        }
      }
    },
    getParentMenu(route) {
      let menu = this.Menu
      if (!menu) {
        return
      }
      for (let i = 0, l = menu.length; i < l; i++) {
        let item = menu[i]
        item.meta.active = false
        // check privileges
        this.checkMenuPrivileges(item)
        if (item.children && item.children.length) {
          for (let j = 0, c = item.children.length; j < c; j++) {
            item.children[j].meta.navActive = false
            let curRouteName = this.$getRouteName(route.name)
            this.checkMenuPrivileges(item.children[j])
            if (route.name && (item.children[j].name === route.name || item.children[j].name === curRouteName)) {
              item.children[j].meta.navActive = true
              item.meta.active = true
              this.parentHeading = this.$t(item.meta.T).tUpper()
              this.heading = this.$t(item.children[j].meta.T).tUpper()
              if (this.isRegistration) {
                this.parentHeading = this.heading
              }
              this.$emit('updateHead')
            }
          }
        } else {
          let curRouteName = this.$getRouteName(route.name)
          if (route.name && (item.name === route.name || item.name === curRouteName)) {
            item.meta.active = true
            this.parentHeading = this.$t(item.meta.T).tUpper()
            this.heading = this.$t(item.meta.T).tUpper()
            this.$emit('updateHead')
          }
        }
      }
      // if mobile do not show
      if (window.innerWidth > 768) {
        this.sidenavHidden = false
      }
    },
    changeLang(event) {
      if (this.Language === null || typeof this.Language === 'undefined') {
        return
      }
      if (event && event.target && event.target.value) {
        this['language/set'](event.target.value)
      }
      // this['language/set'](this.Language)
      window.localStorage.setItem('lang', this.Language)

      // If user is logged in, save the language setting
      if (this.User.info.ID) {
        service
          .post('/users/set-language', {
            userID: this.User.info.ID,
            langCode: this.Language,
          })
          .then(response => {
            if (response.data.success) {
              this.$toasted.success('Language setting saved')
            }
          })
          .catch(error => {
            this.$toasted.error('Unable to save language setting')
          })
      }

      // check if url has language already
      let url = location.pathname.split('/')
      if (url[1] === '' || url[1].length !== 2) {
        this.$router.push('/' + this.Language + '/' + config.defaultURL)
      }
      this.$locale.change(this.Language)
    },
    uddGoTo(path) {
      this.userHeadMenuActive = false
      this.$router.push(path)
    },
    firstLogin(redir) {
      service.get('/users/first-login/' + this.User.info.ID, null, 'userfirstlogin').then(response => {
        if (response.data.success) {
          let i = this.User.info
          i.first_login = 'yes'
          this['user/setInfo'](i)
          if (redir) {
            this.$router.push(redir)
          }
        }
      })
    },
    logout() {
      this.$auth
        .logout({
          makeRequest: false,
          params: {},
          // error: () => {
          // },
          redirect: '/' + this.Language + '/login',
        })
        .then(() => {
          // Success
          this.$deleteCookie('login_license_read')
          this['user/reset']()
        })
    },
    openCompleteProfile() {
      this.$router.push('/' + this.Language + '/profile/complete-profile')
    },
    extraMenuItemChecksPassed(itemChild) {
      let menuItemChecksPassed = true

      if (itemChild.name === 'My Bonuses') {
        if (this.BonusConfig.depositBonus.enabled === false) {
          return false
        }
      }

      return menuItemChecksPassed
    },
    ...mapActions([
      'language/set',
      'bonusconfig/set',
      'user/setInfo',
      'user/reset',
      'user/setAccountTypes',
      'user/setIB',
      'user/setIsDemo',
      'user/setIsLive',
      'user/setIsVerified',
      // 'resetState',
    ]),
  },
}
</script>

<style lang="scss">
@import '~animate.css';

@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700|Roboto+Condensed:300,400,700');
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700,900|Roboto+Condensed:300,400,700,900');
// @import url('https://fonts.googleapis.com/css?family=Slabo+27px');

@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');

@import '~bulma/sass/utilities/initial-variables';
@import 'assets/css/variables';
// $black:		hsl(0, 0%, 4%) !default
// $black-bis:	hsl(0, 0%, 7%) !default
// $black-ter:	hsl(0, 0%, 14%) !default

// $grey-darker:  hsl(0, 0%, 21%) !default
// $grey-dark:	hsl(0, 0%, 29%) !default
// $grey:		 hsl(0, 0%, 48%) !default
// $grey-light:   hsl(0, 0%, 71%) !default
// $grey-lighter: hsl(0, 0%, 86%) !default

// $white-ter:	hsl(0, 0%, 96%) !default
// $white-bis:	hsl(0, 0%, 98%) !default
// $white:		hsl(0, 0%, 100%) !default

// $orange:	   hsl(14,  100%, 53%) !default
// $yellow:	   hsl(48,  100%, 67%) !default
// $green:		hsl(141, 71%,  48%) !default
// $turquoise:	hsl(171, 100%, 41%) !default
// $blue:		 hsl(217, 71%,  53%) !default
// $purple:	   hsl(271, 100%, 71%) !default
// $red:		  hsl(348, 100%, 61%) !default
@import '~bulma/sass/utilities/functions';
@import '~bulma/sass/utilities/derived-variables';
@import '~bulma/sass/utilities/animations';
@import '~bulma/sass/utilities/mixins';
@import '~bulma/sass/utilities/controls';

@import '~bulma/sass/base/_all';
@import '~bulma/sass/elements/_all';
@import '~bulma/sass/components/_all';
@import '~bulma/sass/grid/_all';
@import '~bulma/sass/layout/_all';

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

$headerHeight: 80px;
$topNavHeight: 60px;
$headerColor: #6826f4;
$headerTextColor: #fff;
$sideColor: #10182a;
$sidenavWidth: 260px;
$maxWidth: 1250px;

.table-overflow {
  overflow-x: auto;
}

@-webkit-keyframes shakeSubtle {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-5px, 0, 0);
    transform: translate3d(-5px, 0, 0);
  }
  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0);
  }
}

@keyframes shakeSubtle {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-5px, 0, 0);
    transform: translate3d(-5px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0);
  }
}

.shakeSubtle {
  -webkit-animation-name: shakeSubtle;
  animation-name: shakeSubtle;
}

html {
  height: 100vh;
}

body {
  color: #000;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: $family-condensed;
}

body #toasted-container .toasted.primary {
  padding: 20px 20px;
  font-weight: 400;
  &.error {
    background-color: $secondary;
  }
  .action {
    color: black;
  }
}

#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.content nav.pagination {
  margin-top: 20px;
  // border:1px solid #dbdbdb;
  background-color: #f0f0f0;
  padding: 5px 20px;
  ul.pagination-list {
    margin: 0;
    list-style: none;
  }
}
.notification {
  span.error-id {
    font-size: 12px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 0 5px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.7);
    position: absolute;
    right: 5px;
    top: -8px;
    right: 5px;
    border: 1px solid #f00;
  }
}

.content table .button {
  height: 25px;
}
.content table th,
.content table td {
  vertical-align: middle;
}
.content table thead tr th {
  background-color: $primary;
  color: $white;
  padding: 15px 20px;
  font-size: 14px;
  font-family: $family-condensed;
  line-height: 15px;
  // font-family: $family-table;
}
// .content table tbody tr:nth-child(odd){
// 	background-color:$grey-superlight;
// }
.content table tbody td {
  font-size: 14px;
  padding: 10px 20px;
  border-color: #ccc;
  &.bold {
    font-weight: 700;
  }
  // font-family: $family-table;
  // font-weight: 300;
}

button,
.button {
  font-weight: 700;
  border-radius: 0;
  font-size: 14px;
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
}

.select {
  &.bare {
    select {
      background-color: $red;
      color: $white;
      border: none;
      border-radius: 0;
    }
    &:after {
      border-color: $white;
    }
  }
  &.clean {
    margin-top: 7px !important;
    select {
      border: none;
      font-weight: 700;
      font-size: 13px;
      border-radius: 0;
    }
    &:after {
      border-color: $black;
    }
  }
  &.languages {
    select {
      border: 1px solid $white;
    }
  }
}

.modal {
  &.small {
    .modal-card {
      width: 50vw;
      height: auto;
      min-width: 320px;
      min-height: initial;
      max-width: 600px;
    }
  }
  z-index: 9999;
  .modal-card {
    width: calc(100vw - 100px);
    height: calc(100vh - 80px);
  }
  .modal-card-foot.right {
    justify-content: flex-end;
  }
  .modal-card-head {
    display: block;
    .delete {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
  &.confirm {
    z-index: 99999;
    .modal-background {
      z-index {
        z-index: 0;
        position: fixed;
      }
    }
    div.modal-card {
      min-width: initial !important;
      height: 200px !important;
      width: 400px !important;
    }
  }
  .modal-card-foot {
    &.reverse {
      flex-direction: row-reverse;
      .button:not(:last-child) {
        margin-left: 10px;
        margin-right: 0;
      }
    }
  }
}

.modal.error {
  .modal-card-head .delete {
    margin: 5px;
    background-color: $grey;
  }
  .modal-card {
    max-width: 600px;
    height: auto;
    max-height: 400px;
  }
  .modal-card-body {
    padding-top: 30px;
    padding-bottom: 30px;
    overflow-y: auto;
  }
  .modal-card-foot {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

label {
  font-size: 16px;
  font-family: $family-condensed;
  font-weight: 700;
}

#top-notice {
  width: 100vw;
  padding: 10px;
  // position: fixed;
  // z-index: 9;
  background-color: #efeff0;
  border-bottom: 1px solid #000;

  .wrap {
    max-width: 840px;
    padding: 0 40px;
    text-align: justify;
    margin: auto;
    // margin-left: $sidenavWidth;
    // @media screen and (max-width: $tablet - 1px) {
    // 	margin-left: 0;
    // }
    font-size: 13px;
    line-height: 1.1;
    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    .columns {
      .column.icon {
        min-height: 50px;
        text-align: center;
        i {
          font-size: 50px;
        }
      }
    }
  }
}

#app > header {
  height: $headerHeight;
  width: 100vw;
  background-color: $headerColor;
  color: $headerTextColor;
  // added for holidays
  // margin-top: 34px;
  // position: fixed;
  // top: 0;
  // left:0;
  // z-index: 100;

  .headWrap {
    //max-width: 1460px;
    max-width: auto;
  }

  a:not(.button) {
    color: $black;
  }

  h1.title {
    color: $white;
    float: left;
    margin: 0 80px;
    font: normal normal 900 30px/80px Roboto;
    @media screen and (max-width: $tablet - 1px) {
      text-align: right;
      font-size: 16px;
      margin: 0;
      padding: 0 0 0 15px;
    }
    @media screen and (max-width: $mobile) {
      width: calc(100vw - 151px);
      float: none;
      display: inline-block;
      line-height: 20px;
      padding: 17px 20px 0 15px;
    }
  }

  .profile-head-icon {
    line-height: 80px;
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
    }
  }

  .action {
    padding: 0 10px 0 0;
    height: 100%;
    line-height: $headerHeight;
    @media screen and (max-width: $mobile) {
      width: calc(100vw - 151px);
      display: inline-block;
      text-align: right;
      line-height: 30px;
      padding: 0 20px 0 0;
    }

    .dropdown-item {
      &.big {
        margin: 15px 0;
      }
      > .half {
        width: 49%;
        float: left;
      }
    }

    .button {
      margin: 15px 20px 0 0;
      line-height: 10px;
      &.main {
        border-radius: 0;
        height: 27px;
        margin-top: 25px;
        font-size: 0.7rem;
        padding: 0 20px;
        &.login {
          border: 0;
          color: white;
          background: #e04ef8 0% 0% no-repeat padding-box;
          border-radius: 23px;
          width: 117px;
          height: 32px;
          font: normal normal 600 12px/14px Roboto;
          letter-spacing: 0px;
          transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
          -ms-transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
        }
        &.login:hover {
          color: #ffffff;
          background-color: $black;
          transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
          -ms-transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
        }
      }
    }
    .dropdown.user {
      cursor: pointer;
      margin-right: 25px;
      @media screen and (max-width: $mobile) {
        margin-right: 0;
      }
      .welcome {
        margin-right: 10px;
        font-size: 14px;
        // span {
        // 	color: $black;
        // 	font-weight:700;
        // }
        @media screen and (max-width: $tablet - 1px) {
          span {
            float: left;
            line-height: 20px;
            margin-top: 20px;
            text-align: right;
            b {
              font-size: 11px;
              display: block;
            }
          }
          // display: none;
        }
      }
    }
    #user-dropdown {
      margin-top: -20px;
      width: 482px;
      height: 220px;
      box-shadow: 0px 0px 30px #00000029;
      @media screen and (max-width: $mobile) {
        margin-top: -5px;
        width: 320px;
        height: auto;
      }
      .dropdown-content {
        background-color: white;
        border-radius: 0;
        box-shadow: none;
        padding-bottom: 0.5rem;
        padding-top: 1rem;
        padding-left: 0.5rem;
        height: 100%;
      }
      .dropdown-item {
        padding: 0 1rem;
        .button {
          width: 140px;
          height: 37px;
          float: left;
          border-radius: 23px;
          margin-right: 10px;
          font-size: 11px;
          font-family: 'Roboto', sans-serif;
          line-height: 14px;
          font-weight: 500;
          margin-top: 30px;
          &:nth-child(1) {
            color: #10182a;
            background-color: #3bed83;
          }
          &:nth-child(2) {
            color: #fff;
            background-color: #ee7a31;
          }
          &:nth-child(3) {
            color: #6826f4;
            background-color: white;
            border: 1px solid #6826f4;
            margin-right: 0;
          }
        }
        .balance {
          color: #6826f4;
          font-size: 19px;
          font-family: $family-primary;
          font-weight: 900;
          letter-spacing: normal;
          line-height: 20px;
          text-transform: capitalize;
          span {
            color: #10182a;
            font-size: 34px;
            line-height: 37px;
          }
        }
      }
      .profile_buttons {
        display: table;
        float: none;
        width: 100%;
      }
      .logout-dropdown-item {
        position: absolute;
        top: 0;
        .button:nth-child(1) {
          height: 32px;
          width: 117px;
          background-color: #6826f4;
          color: #fff;
          line-height: 15px;
        }
      }
      .logout-dropdown-item.position-right {
        right: 0;
      }
      .lang-dropdown-item {
        margin-top: 10px;
        select {
          padding-right: 1.9em;
          color: #10182a;
          font-family: $family-primary;
          font-weight: 500;
        }
        .select:not(.is-multiple)::after {
          top: 54%;
          border-color: #10182a;
        }
      }
      .dropdown-divider {
        background-color: $primary;
        width: 86%;
        margin-left: 7%;
      }
    }
    .select {
      margin-top: $headerHeight / 2 - 15;
    }
    .menu-list {
      cursor: pointer;
      position: relative;
      margin-top: $headerHeight / 2 - 15;
      font-size: 0.75rem;
      li a {
        color: $headerTextColor;
        padding-right: 21px;
        &:after {
          border: 1px solid $white;
          border-right: 0;
          border-top: 0;
          content: ' ';
          display: block;
          height: 0.5em;
          pointer-events: none;
          position: absolute;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          width: 0.5em;
          margin-top: -0.375em;
          right: 0.7em;
          top: 13px;
          z-index: 4;
        }
      }
      ul {
        li a {
          color: $black;
        }
        display: none;
        background-color: $white;
        border: none; // 1px solid $red;
        margin: 0;
        &.is-active {
          display: block;
        }
      }
    }
  }

  .logo {
    background-color: #10182a;
    display: block;
    float: left;
    width: $sidenavWidth;
    height: $headerHeight;
    position: relative;
    margin: 0 auto;
    text-align: center;
    img {
      margin-top: 13px;
      max-width: 176px;
      width: 90%;
      padding: 5%;
    }
    @media screen and (max-width: 1023px) {
      .icon {
        margin-top: 1em;
      }
    }
    @media screen and (max-width: $tablet - 1px) {
      width: 151px;
      padding-top: 16px;
      .icon {
        margin-top: 0;
      }
      img {
        max-width: 100px;
        margin-top: 7px;
      }
    }
  }
}

main {
  min-height: 77vh;
  // width:calc(100%-$sidenavWidth);
  flex: 1;
  overflow-x: auto;
  background-color: #10182a;
  // min-height: calc(100vh - 370px);
  > .content {
    padding: 20px 0;
  }
  // margin:($headerHeight + $topNavHeight) 0 0 $sidenavWidth;
  // padding:40px 80px 100px;
  padding: 0;
  // max-width: $maxWidth;
  &.noSideNav {
    width: 100vw;
    // margin-top: ($headerHeight + $topNavHeight);
    margin-left: 0;
    margin-right: 0;
    .topnav,
    section#content {
      width: 100vw;
      max-width: auto;
    }
    section#content {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
  &.solo {
    width: 100vw;
    max-width: auto;
    margin: 0 auto;
    background-color: transparent;
    @media screen and (max-width: $tablet - 1px) {
      padding: 0 15px;
    }
    section#content {
      background-color: transparent;
      width: 100%;
    }
  }
  &.register {
    width: 100vw;
    margin: $headerHeight auto 0;
    section#content {
      width: 100%;
    }
  }
  h2 {
    color: $black;
    font-weight: 700;
    font-size: 24px;
    border-bottom: 1px solid $black;
    max-width: $maxWidth;
    margin: auto;
  }
  @media screen and (max-width: $tablet - 1px) {
    padding-left: 10px;
    padding-right: 10px;
    .topnav,
    section#content {
      clear: both;
      width: 100vw;
      float: none;
    }
    // margin: ($headerHeight + $topNavHeight) auto 0;
  }
}

.sidenav {
  // position:fixed;
  // left:0;
  // top: $headerHeight;
  // z-index:20;
  float: left;
  background-color: $sideColor;
  width: $sidenavWidth;
  overflow-y: auto;
  // height:calc(100vh - #{$headerHeight} );
  padding: 0 0 20px 0;
  @media screen and (max-width: $tablet - 1px) {
    padding-top: 20px;
  }
  .account-status {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: $family-primary;
    font-weight: bold;
    margin: 0 22px 30px;
    background-color: transparent;
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
    height: 27px;
    font-size: 13px;
    min-height: inherit;
    text-transform: capitalize;
    &.incomplete {
      border-color: #f00;
      color: #f00;
    }

    &.pending {
      border-color: $purple;
      color: $purple;
    }

    &.full {
      border-color: #3bed83;
      color: #3bed83;
    }
  }

  .button.centered {
    margin: 20px auto 0;
    display: table;
    font-weight: 500;
    border-radius: 23px;
    font-size: 11px;
    width: 140px;
    font-family: $family-primary;
    a {
      margin: 0;
      padding: 0;
      line-height: 35px;
      font-size: 11px;
      font-weight: 500;
      font-family: $family-primary;
    }
  }
  li {
    position: relative;
    padding: 0;
    margin-left: 17px;
    margin-right: 17px;
    border-radius: 5px;
    height: 41px;
    margin-bottom: 10px;
    &.is-active {
      background-color: #6826f4;
    }
    &:hover {
      background-color: #6826f4;
    }
  }
  a {
    display: block;
    line-height: 44px;
    padding: 0 0 0 65px;
    width: 100%;
    height: 100%;
    color: $white;
    font-size: 15px;
    font-family: $family-primary;
    font-weight: 400;
    text-transform: capitalize;
  }
  i.icon {
    position: absolute;
    left: 23px;
    top: 10px;
    background: transparent center;
    width: 25px;
    height: 25px;
    margin-right: 10px;
    box-shadow: none;
    &.card {
      background-image: url('./assets/img/icons/card.svg');
    }
    &.graph {
      background-image: url('./assets/img/icons/graph.svg');
    }
    &.group {
      background-image: url('./assets/img/icons/group.svg');
    }
    &.line-graph {
      background-image: url('./assets/img/icons/line-graph.svg');
    }
    &.partners {
      background-image: url('./assets/img/icons/partners.svg');
    }
    &.profile {
      background-image: url('./assets/img/icons/profile.svg');
    }
    &.quickmenu {
      background-image: url('./assets/img/icons/quickmenu.svg');
    }
  }
}

.sidenav li.is-active a {
  font-weight: 500;
}
section#content {
  float: left;
  width: calc(100% - #{$sidenavWidth});
  padding: 50px 80px 100px;
  background-color: $white;
  min-height: calc(100vh - #{$headerHeight} - 200px);
  .content {
    max-width: $maxWidth;
    margin: auto;
  }
}

.topnav {
  // position:fixed;
  // top: $headerHeight;
  // left: $sidenavWidth;
  float: left;
  width: calc(100% - #{$sidenavWidth});
  height: $topNavHeight;
  padding: 0 30px;
  background-color: $grey-superlight;
  border-bottom: 1px solid #e6e6e6;
  z-index: 1;
  @media screen and (max-width: $tablet - 1px) {
    left: 0;
  }
  .nav {
    background-color: transparent;
  }
  a {
    font-family: $family-condensed;
    font-size: 13px;
    &.is-active {
      color: $black;
      font-weight: 700;
      position: relative;
      &:after {
        content: '';
        display: block;
        width: 90%;
        height: 3px;
        background-color: $primary;
        position: absolute;
        left: 5%;
        bottom: 0;
      }
      // border-bottom:3px solid $red;
    }
  }

  i.icon {
    background: transparent center;
    width: 15px;
    height: 15px;
    &.quickmenu {
      background-image: url('./assets/img/icons/quickmenu-small.svg');
    }
  }
}

#app > footer {
  width: 100%;
  background-color: #10182a;
  border-top: solid $secondary 3px;
  z-index: 20;
  @media screen and (max-width: $tablet - 1px) {
    z-index: 1;
  }

  #footerMain {
    max-width: 1050px;
    width: calc(100% - 460px);
    margin: 0 auto;
    margin-top: 30px;
    @media screen and (max-width: $desktop) {
      width: 100%;
      margin: 0;
      padding: 20px 15px;
    }
    #footerRow1 {
      height: 50px;

      #footerLogoContainer {
        width: 176px;
        height: 27px;
        float: left;
      }
      #slogan {
        width: 200px;
        height: 35px;
        float: right;
      }
      @media screen and (max-width: $desktop) {
        height: auto;
        #footerLogoContainer {
          width: 100%;
          max-width: 176px;
          margin: 0 auto;
          float: none;
        }
        #slogan {
          display: block;
          width: 100%;
          max-width: 200px;
          margin: 10px auto;
          float: none;
        }
      }
    }

    #footerRow2 {
      margin-top: 15px;
      font-size: 11px;
      color: #fff;
      display: inline-block;
      /* sotiris */
      border-top: solid 1px #293b64;
      border-bottom: solid 1px #293b64;
      padding-top: 15px;
      padding-bottom: 20px;

      .contentLeft {
        width: calc(100% - 260px);
        padding-right: 20px;
        border-right: solid 1px #293b64;
        float: left;
        .footerTitle {
          color: white;
          font-weight: 900;
        }
      }
      .contentRight {
        width: 260px;
        float: right;
        padding-left: 20px;
        .social,
        .contacts {
          // float: right;
          text-align: left;

          clear: both;
          p {
            font: normal normal bold 18px/24px Roboto;
            color: white;
          }
        }
      }

      @media screen and (max-width: $desktop) {
        .contentLeft,
        .contentRight {
          width: 100%;
          float: none;
        }
        .contentRight {
          margin-top: 20px;
          .social,
          .contacts {
            float: none;
            text-align: center;
          }
        }
      }
    }
  }
}

.label {
  @media screen and (max-width: $mobile) {
    font-size: 13px;
    line-height: 13px;
  }
}

.convertPartnerCurrencyWarning {
  font-size: 11px;
  color: #ff0000;
  margin-top: 5px;
  font-weight: 600;
}

.nprogress-container {
  position: fixed !important;
  top: 0;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;

  #nprogress {
    $color: #48e79a;

    .bar {
      background: $color;
      height: 3px;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }

    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}

.vdp-datepicker input {
  padding: 9px 20px;
  border-radius: 3px;
  outline: none;
  border: 1px solid #ccc;
}

@media only screen and (max-width: $tablet - 1px) {
  table.is-responsive {
    // th:nth-child(3),
    // td:nth-child(3),
    th {
      display: none;
    }
    tr td {
      padding: 0 !important;
      border: none !important;
      border-bottom: 1px solid #ddd !important;
      // &:not(.is-mobile-full) {
      // display:inline-block !important;
      // }
      &.is-mobile-full {
        margin-top: 10px;
        border: none !important;
      }
      line-height: 20px !important;
      span {
        min-width: 30%;
        display: inline-block;
      }
    }

    tbody tr {
      display: block;
      // overflow: hidden;
      max-width: 100vw;
      padding: 15px;
      border-bottom: 1px solid #000;
      margin: 5px 10px 0;
    }

    td p.sm {
      display: inline;
      margin-right: 10px;
      font-weight: 700;
    }

    tr > td {
      display: block;
      padding: 5px 0;
    }

    td a {
      &.btn {
        width: 50%;
        margin: 0 auto 5px;
        display: block;
        float: none;

        &.alt,
        &:first-of-type {
          width: 50%;
          margin: 0 auto 5px;
          display: block;
          float: none;
        }
      }

      &.changePassword {
        float: right;
      }
    }
  }
}

.notification.uploadDocuments {
  margin: 0;
  padding: 20px 20px;
  position: fixed;
  bottom: 15px;
  left: 0px;
  width: 100%;
  font-size: 18px;
  text-align: center;
  border-radius: 0;
  z-index: 99999;
  @media screen and (max-width: $mobile) {
    font-size: 12px;
  }
  a {
    font-weight: 700;
    color: $white !important;
  }
}

.userMobile {
  line-height: 1.5;
  padding-top: 15px;
  .icon {
    border: 2px solid $white;
    padding: 15px;
    border-radius: 50%;
    i {
      font-size: 22px;
    }
  }
}

#new-version-message {
  position: fixed;
  left: 50%;
  bottom: 5px;
  min-width: 300px;
  z-index: 99999;
  width: 96%;
  width: 66%;
  // height: 55px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  transform: translateX(-50%);
  text-align: center;
  padding: 5px 40px;
  // font-size: 1.3rem;
  // font-weight: 700;
  font-family: $family-condensed;
  cursor: pointer;
  border: 1px solid #ccc;
  background-color: #ff0000;
  border-radius: 5px;
  // text-shadow: 1px 1px 1px rgba(255, 255, 255, .2);
  p {
    color: #fff;
    width: 100%;
    &.title {
      text-decoration: underline;
    }
  }
}

.LPMcontainer {
  margin: -100px 0 0 auto !important;
  background-image: url('./assets/img/livechat.svg');
  background-repeat: no-repeat;
  top: 70% !important;
}
.LPMcontainer > img {
  display: none;
}

.first-login-background {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
}
.first-login {
  background-color: white;
  padding: 0px;
  position: fixed;
  width: 600px;
  left: calc(50% - 300px);
  top: 20px;
  z-index: 20;

  border-radius: 4px;

  @media screen and (max-width: $tablet) {
    width: 340px;
    left: calc(50% - 170px);
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^='top'] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='right'] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^='left'] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}

.has-cursor-pointer {
  cursor: pointer;
}

.cc-color-override-1954199994.cc-window {
  bottom: 25px !important;
  left: 30px;
  width: auto;
  box-shadow: none;
  background-color: #10182a !important;
  border: 1px #3bed83 solid;
  box-shadow: 0px 3px 8px #ffffff29;
  border-radius: 12px;
  display: block;
  margin: 0 auto;
  height: 180px;
  width: 320px;
  padding: 28px 21px;
  @media screen and (max-width: $tablet) {
    top: 38%;
    right: auto;
    bottom: auto !important;
    width: 90%;
    left: 5%;
    right: 5%;
    max-width: 320px;
  }
}

.cc-floating.cc-theme-edgeless .cc-message {
  margin: 0;
  width: 278px;
  line-height: 22px;
  font-family: 'Faktum Regular', sans-serif;
  font-size: 13px;
  color: #fff;
}

.cc-floating.cc-theme-edgeless .cc-message img.emoji {
  display: inline !important;
  border: none !important;
  box-shadow: none !important;
  height: 1em !important;
  width: 1em !important;
  margin: 0 0.07em !important;
  vertical-align: -0.1em !important;
  background: none !important;
  padding: 0 !important;
}

.cc-floating .cc-compliance > .cc-btn {
  margin: 0;
  font-family: 'Epilogue Medium', sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  color: rgb(16, 24, 42);
  background-color: rgb(59, 237, 131);
  border-radius: 23px;
  width: 100% !important;
  outline: none;
  height: 40px;
  margin-left: 0px !important;
  margin-right: 0 !important;
  margin-top: 17px !important;
  line-height: 27px;
}

.cc-color-override-1954199994 .cc-link {
  outline: none;
}

.cc-color-override-1954199994 .cc-btn:hover {
  background-color: rgb(59, 237, 131) !important;
}

.message {
  height: auto;
  width: 660px;
  margin: 0 auto;
  margin-top: 7%;
  display: table;
  box-shadow: 5px 5px 20px #0000001a;
  border-radius: 0px 0px 30px 0px;
  background-color: #f7f6fd;
  .message-header {
    background-color: #f7f6fd;
    color: #6826f4;
    font-size: 22px;
    line-height: 18px;
    letter-spacing: -0.44px;
    font-family: $family-sans-serif;
    font-weight: 900;
    text-transform: uppercase;
    text-align: center;
    margin: 0 auto;
    padding-top: 74px;
    p {
      width: 77%;
      margin: 0 auto;
      max-width: 426px;
    }
    button.delete {
      top: 5px;
      width: 29px;
      height: 29px;
      right: 30px;
      position: absolute;
      background-color: transparent;
      &::before {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 29px;
        width: 1px;
        background-color: #000;
        transform: rotate(45deg);
      }
      &::after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 29px;
        width: 1px;
        background-color: #000;
        transform: rotate(-45deg);
      }
    }
  }
  .message-body {
    font-size: 16px;
    color: #10182a;
    font-family: $family-sans-serif;
    font-weight: 300;
    line-height: 24px;
    border: 0;
    p {
      margin-bottom: 20px;
      a:not(.button):not(.tag) {
        color: #6826f4;
        text-decoration: none;
        font-weight: 700;
      }
    }
    ul {
      margin-bottom: 20px;
      list-style-type: decimal;
      margin-left: 20px;
      li {
        &::marker {
          color: #6826f4;
          font-weight: 700;
        }
      }
    }
  }
  .button.is-primary {
    width: 152px;
    height: 40px;
    border-radius: 23px;
    background-color: #6826f4;
    margin: 0 auto;
    display: table;
    margin-bottom: 40px;
    font-family: $family-sans-serif;
    font-size: 12px;
    line-height: 38px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?4bd6c839